import mapboxgl from 'mapbox-gl';
import maplibregl from "maplibre-gl";

export default {
    data() {
        return {
            locationMarkers: new Map(),
            clusterMarkers: new Map(),
        }
    },
    methods: {
        addClusterMarker(feature) {
            var self = this;
            const coordinates = feature.geometry.coordinates;
            let bubbleDiv = this.$refs['clusterMarkerTemplate'].cloneNode(true);
            let bubbbleLink = bubbleDiv.querySelector('.bubble_link');
            let countBox = bubbleDiv.querySelector('.count_box');
            bubbbleLink.innerHTML = `<span loading="lazy" class="inline rounded-full bg-cover w-10 h-10 marker-size" style="background-image:url(${feature.properties.marker_image_url});"/></span>`;

            countBox.textContent = feature.properties.point_count;

            bubbleDiv.addEventListener('click', function () {
                self.mySmartMap.flyTo({
                    center: coordinates,
                    zoom: feature.expansion_zoom +3,
                    speed: 1.8
                });
            });

            const el = document.createElement('div');
            el.appendChild(bubbleDiv);

            const marker = self.useMaplibre
            ? new maplibregl.Marker(el).setLngLat(coordinates).addTo(this.mySmartMap)
            : new mapboxgl.Marker(el).setLngLat(coordinates).addTo(this.mySmartMap);

            this.clusterMarkers.set(feature.id, marker);
        },
        addLocationMarker(feature) {
            var self = this;
            let bubbleDiv = this.$refs['locationMarkerTemplate'].cloneNode(true);
            let bubbbleLink = bubbleDiv.querySelector('.bubble_link');
            let stamGroup = bubbleDiv.querySelector('.stamp_group');

            const currentCongestion = feature.properties.current_congestion;
            if (currentCongestion && currentCongestion.level) {
                bubbleDiv.style.cssText = 'display: flex;justify-content: center;';
                let congestionElement = document.querySelector(`#congestion-level-${currentCongestion.level}`);
                congestionElement.querySelector('.title').innerText = currentCongestion.title;
                let currentCongestionTooltip = bubbleDiv.querySelector('#currentCongestionTooltip');
                currentCongestionTooltip.innerHTML = congestionElement.innerHTML;
                currentCongestionTooltip.style.cssText = `display:block; position: absolute;bottom: 100%;white-space: nowrap;`;
            }

            feature.properties.items.forEach((item, index) => {
                let a = document.createElement('a');
                a.classList.add('stamp_link');
                a.setAttribute('href', 'javascript:void(0)');
                a.style.left = -(index * 15) - 6 + 'px';
                a.innerHTML = `<span loading="lazy" class="inline rounded-full bg-cover w-5 h-5" style="background-image:url(${item.image_url});"></span>`;

                stamGroup.appendChild(a);
            });
            bubbbleLink.innerHTML = `<span loading="lazy" class="inline rounded-full bg-cover marker-size" style="background-image:url(${feature.properties.marker_image_url});"></span>`;

            const { use_custom_color, color } = feature.properties.category;
            if (use_custom_color && color) {
                bubbleDiv.style.backgroundColor = color;
            }

            if (feature.properties.marker_style == 'round') {
                bubbleDiv.classList.add('round-marker');
                bubbleDiv.querySelector('span').classList.add('marker-border');
                bubbleDiv.querySelector('span').classList.add('bg-base-100');
            }else if (feature.properties.marker_style == 'square') {
                bubbleDiv.classList.add('square-marker','rounded');
                bubbleDiv.querySelector('span').classList.remove('p-1','rounded-full');
                bubbleDiv.querySelector('span').classList.add('rounded','marker-border');
                bubbleDiv.querySelector('span').classList.add('bg-base-100');
            } else if (feature.properties.marker_style == 'icon') {
                bubbleDiv.classList.remove('bubble','pin','btn','h-12','w-12','rounded-full');
                bubbleDiv.classList.add('icon-marker','bg-base-100','h-7','w-7','rounded');
                bubbleDiv.querySelector('span').classList.remove('w-10','h-10');
                bubbleDiv.querySelector('span').classList.add('rounded','w-6','h-6','icon-size');
                stamGroup.style.display = 'none';
            } else if (feature.properties.marker_style == 'custom') {
                bubbleDiv.classList.remove('bubble','pin','btn','h-12','w-12','bg-primary');
                bubbleDiv.classList.add('custom-marker','h-14','w-14');
                bubbleDiv.querySelector('span').classList.remove('rounded-full');
                stamGroup.style.display = 'none';
                bubbleDiv.style.backgroundColor = '';
            } else if (feature.properties.marker_style == 'illustration') {

                bubbleDiv.style.display = 'none';
                this.mySmartMap.on('render', () => {
                    var myImage = new Image();
                    myImage.src = feature.properties.illustration_image ? feature.properties.illustration_image.image_url : '';
                    var spanElement = bubbleDiv.querySelector('span');
                    var currentVal = this.mySmartMap.getZoom();
                    var routeName = window.location.pathname.split('/')[3];
                    var originalZoomLevel = routeName == 'parcels' ? this.parcelResource.zoom_level : this.mapData.zoom_level;
                    var perOfWidth = feature.properties.illustration_image ? feature.properties.illustration_image.width_size/100 : 1;
                    var spanWidth = myImage.width ? myImage.width * perOfWidth : 44;
                    var spanHeight = myImage.height ? myImage.height * perOfWidth : 44;
                    var scale = Math.pow(2, (currentVal - originalZoomLevel));
                    bubbleDiv.classList.remove('bubble','pin','btn','h-12','w-12','bg-primary');
                    bubbleDiv.classList.add('illustration-marker');
                    spanElement.classList.remove('rounded-full', 'marker-size','marker-border');
                    spanElement.style.cssText = feature.properties.illustration_image ? `${feature.properties.illustration_image.custom_style_css}` : '';
                    spanElement.style.backgroundImage = feature.properties.illustration_image ? `url(${feature.properties.illustration_image.image_url})` : '';
                    spanElement.style.width = spanWidth * scale + 'px';
                    spanElement.style.height = spanHeight * scale + 'px';
                    bubbleDiv.style.transform = `rotate(${this.bearing}deg)`;
                    bubbleDiv.style.display = '';
                    stamGroup.style.display = 'none';
                    bubbleDiv.style.backgroundColor = '';
                });
            } else if (feature.properties.marker_style == 'point') {
                bubbleDiv.classList.remove('bubble', 'bg-primary');
                bubbleDiv.classList.add('point-marker');
                let spanElement = bubbleDiv.querySelector('span');
                spanElement.classList.remove('p-1','rounded-full', 'bg-cover', 'marker-size');
                spanElement.innerHTML = `
                    <svg xmlns="http://www.w3.org/2000/svg" height="44" viewBox="0 0 20 20">
                        <g transform="translate(-3.5 -2.5)">
                            <path d="M12.952,20.9C15.073,19.493,20,15.709,20,11A8,8,0,0,0,4,11c0,4.709,4.927,8.493,7.048,9.9A1.707,1.707,0,0,0,12.952,20.9Z" 
                                stroke-width="1" 
                                class="path-fill"/>
                            <path d="M20,11a9.5,9.5,0,0,1-2.566,6,22.113,22.113,0,0,1-4.481,3.9,1.711,1.711,0,0,1-1.907,0A22.113,22.113,0,0,1,6.566,17,9.5,9.5,0,0,1,4,11a8,8,0,0,1,16,0Z" 
                                fill="none" 
                                stroke="#6e6e6e" 
                                stroke-width="1"/>
                        </g>
                        <foreignObject x="2" y="2" width="13" height="13">
                            <div class="point-bg circle-bg rounded-full" style="width: 100%; height: 100%;"></div>
                        </foreignObject>
                    </svg>`;

                if (use_custom_color && color) {
                    const pathElement = spanElement.querySelector('path.path-fill');
                    if (pathElement) {
                        pathElement.setAttribute('fill', color);
                    }
                } else {
                    const defaultPathElement = spanElement.querySelector('path.path-fill');
                    if (defaultPathElement) {
                        defaultPathElement.setAttribute('fill', '#ffffff');
                    }
                
                    const pointBgElement = spanElement.querySelector('.point-bg');
                    if (pointBgElement) {
                        pointBgElement.classList.add('bg-primary');
                    }
                }
                if (feature.properties.marker_image_url) {
                    spanElement.querySelector('div').style.cssText = `background-image: url(${feature.properties.marker_image_url})`;
                }
                

                spanElement.querySelector('svg').style = 'position:absolute;top:15px;left:4.5px';
                stamGroup.style.display = 'none';
                bubbleDiv.style.backgroundColor = '';
                bubbleDiv.style.top = '-2.1rem';
            }
            bubbleDiv.classList.add('marker-box');
            const el = document.createElement('div');
            el.id = 'spot-' + feature.properties.id;
            el.appendChild(bubbleDiv);

            if (this.mapData.show_tooltip && feature.properties.marker_style != 'illustration') {
                this.addLocationMarkerTooltip(feature, el);
            } else {
                bubbleDiv.addEventListener('mousemove', function (e) {
                    let tooltip = {
                        id: feature.properties.id,
                        title: feature.properties.title,
                        // category_title: feature.properties.category.title,
                        top: e.y + 20 + 'px',
                        left: e.x + 20 + 'px'
                    };
                    self.updateTooltip(tooltip);
                });
                bubbleDiv.addEventListener('mouseout', function (e) {
                    let tooltip = {
                        title: '',
                        top: '',
                        left: ''
                    };
                    self.updateTooltip(tooltip);
                });
            }

            el.addEventListener('click', function () {
                self.triggerEventGA('show_location', {
                    id: feature.properties.id,
                    title: feature.properties.title
                });

                self.triggerEventGA('click_category', {
                    id: feature.properties.category.id,
                    title: feature.properties.category.title
                });

                self.onClickMarker(feature.properties.id);
            });

            const marker = self.useMaplibre
            ? new maplibregl.Marker(el).setLngLat(feature.geometry.coordinates).addTo(this.mySmartMap)
            : new mapboxgl.Marker(el).setLngLat(feature.geometry.coordinates).addTo(this.mySmartMap);

            if (feature.properties.marker_style == 'illustration') {
                marker.setRotation(-this.mySmartMap.getBearing());
            }

            this.locationMarkers.set(feature.properties.id, marker);
        },
        addLocationMarkerTooltip(feature, el) {
            const { use_custom_color, color } = feature.properties.category;
            el = el || document.getElementById('spot-' + feature.properties.id);

            const tooltipEl = document.createElement('div');
            tooltipEl.id = 'tooltip-' + feature.properties.id;
            tooltipEl.classList.add("tooltip-box", "absolute", "inset-0", "flex", "items-center");

            const markerTitle = (this.mapData.tooltip_title_zoom < this.mapData.tooltip_zoom ||
                                 this.currentZoomLevel >= this.mapData.tooltip_title_zoom)
                                 ? feature.properties.title : '';

            const markerStyleClass = feature.properties.marker_style === 'custom' ? 'custom-tooltip-ttl' : 'tooltip-ttl';

            tooltipEl.innerHTML = `
                <div class="tooltip-marker bg-primary h-2 w-2 rounded-full"></div>
                <div id="markerTitle" class="text-xs font-bold ${markerStyleClass} text-black text-opacity-80">${markerTitle}</div>
            `;

            if (use_custom_color && color) {
                tooltipEl.querySelector('.tooltip-marker').style.backgroundColor = color;
            }

            const existingTooltip = el.querySelector(`#tooltip-${feature.properties.id}`);
            if (existingTooltip) {
                existingTooltip.querySelector('#markerTitle').innerHTML = markerTitle;

                if (use_custom_color && color) {
                    existingTooltip.querySelector('.tooltip-marker').style.backgroundColor = color;
                }

                return this.handleTooltipZoomRange(el);
            }

            el.appendChild(tooltipEl);
            this.handleTooltipZoomRange(el);
        },
        removeLocationMarker(locationId) {
            if (!this.locationMarkers.has(locationId)) return;
            this.locationMarkers.get(locationId).remove();
            this.locationMarkers.delete(locationId);
        },
        removeClusterMarker(clusterId) {
            if (!this.clusterMarkers.has(clusterId)) return;
            this.clusterMarkers.get(clusterId).remove();
            this.clusterMarkers.delete(clusterId);
        },
        hideAllMarkersExcept(id) {
            var markers = document.getElementsByClassName('mapboxgl-marker');
            const markerLength = markers.length;
            for (let i = 0; i < markerLength; i++) {
                const marker = markers[i];
                if (marker.id != `spot-${id}`) {
                    marker.style.display = 'none';
                } else {
                    marker.querySelector('div').classList.add('isactived');
                }
            }
        },
        showAllMarkers() {
            var markers = document.getElementsByClassName('mapboxgl-marker');
            const markerLength = markers.length;
            for (let i = 0; i < markerLength; i++) {
                if (markers[i].id.startsWith('area')) {
                    continue;
                }
                markers[i].style.display = '';
                markers[i].querySelector('div').classList.remove('isactived');
            }
        },
        handleTooltipZoomRange(el) {
            const tooltipBox = el.querySelector('.tooltip-box');
            const markerBox = el.querySelector('.marker-box');
            const bubble = el.querySelector('.bubble');
            const tooltipMarker = el.querySelector('.tooltip-marker');
            const iconMarker = el.querySelector('.icon-marker');
            const customMarker = el.querySelector('.custom-marker');
            const pointMarker = el.querySelector('.point-marker');

            if (this.currentLocation && 'spot-' + this.currentLocation.properties.id === el.getAttribute('id')) {
                markerBox.style.display = 'block';
                if (tooltipBox && tooltipMarker) {
                    tooltipBox.style.display = 'block';
                    tooltipMarker.style.display = 'block';
                    tooltipBox.style.transform = 'translate(45%, 50%)'
                    if (!bubble) {
                        tooltipBox.style.transform = 'translate(50%, 50%)'
                        markerBox.style.bottom = '23px';
                        markerBox.style.transform = 'translate(10%)'
                        if (iconMarker) {
                            iconMarker.classList.add('icon-pin');
                            tooltipBox.style.transform = 'translate(50%, 50%)'
                            markerBox.style.transform = 'translate(10%, -95%)'
                        }
                        if (customMarker) {
                            customMarker.style.left = '0px';;
                        }
                        if (pointMarker) {
                            tooltipBox.style.transform = 'translate(45%, 40%)';
                            markerBox.style.transform = 'translate(0, -15%)';
                        }
                    }
                }
                return;
            }

            const showTooltipBox = this.mySmartMap.getZoom() >= this.mapData.tooltip_zoom;
            const showLocationMarker = this.mySmartMap.getZoom() >= this.mapData.location_zoom_range[0];

            tooltipBox.style.display = showTooltipBox ? 'block' : 'none';
            tooltipMarker.style.display = showLocationMarker ? 'none' : 'block';
            markerBox.style.display = showLocationMarker ? 'block' : 'none';

            if (showLocationMarker) {
                tooltipBox.style.transform = 'translate(45%, 50%)'
                if (!bubble) {
                    tooltipBox.style.transform = 'translate(50%, 50%)'
                }
                if (iconMarker) {
                    tooltipBox.style.transform = 'translate(50%, 110%)'
                    markerBox.style.transform = 'translate(0)'
                    iconMarker.classList.remove('icon-pin');
                }
                if (pointMarker) {
                    tooltipBox.style.transform = 'translate(45%, 40%)'
                    markerBox.style.transform = 'translate(0)'
                }
            }
        },
        handleRotateMarker(location) {
            if (location.properties.marker_style != 'illustration') return;
            this.mySmartMap.on('render', () => {
                var spotElement = document.getElementById('spot-' + location.properties.id);
                if (spotElement == null) return;
                var oldTransform = spotElement.style.transform;
                let regex = /rotateZ(.*?)deg\)/;
                let rotateZ = -this.mySmartMap.getBearing();
                if (regex.test(oldTransform)) {
                    var newTransform = oldTransform.replace(regex, `rotateZ(${rotateZ}deg)`);
                } else {
                    var newTransform = `${oldTransform} rotateZ(${rotateZ}deg)`;
                }
                spotElement.style.transform = newTransform;
            });
        }
    }
}